import { useState } from "react";
import { ApiError, signIn } from "../lib/api";

/**
 * Operator sign-in. Replaces "paste your gateway API key" so the console is
 * protected by credentials the operator can rotate and sign out of, instead of
 * a key that also grants raw API access.
 */
export default function LoginPage({
  onSignedIn,
  onUseApiKey,
  error: initialError,
}: {
  onSignedIn: () => void;
  onUseApiKey?: () => void;
  error?: string | null;
}) {
  const [username, setUsername] = useState("admin");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(initialError ?? null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await signIn(username.trim(), password);
      onSignedIn();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Sign-in failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <div className="panel w-full max-w-lg p-8">
        <div className="mb-1 text-[11px] font-semibold uppercase tracking-[0.2em] text-accent">
          InferMesh
        </div>
        <h1 className="mb-2 text-2xl font-semibold tracking-tight">NEXUS Console</h1>
        <p className="mb-6 text-sm text-canvas-muted">
          Sign in to manage providers, credentials, routing policy and request history.
        </p>

        <form onSubmit={submit}>
          <label className="label">Username</label>
          <input
            className="input mb-4"
            value={username}
            autoComplete="username"
            placeholder="nabil"
            autoFocus
            onChange={(e) => setUsername(e.target.value)}
          />

          <label className="label">Password</label>
          <input
            className="input mb-4"
            type="password"
            value={password}
            autoComplete="current-password"
            placeholder="••••••••"
            onChange={(e) => setPassword(e.target.value)}
          />

          {error ? (
            <div className="mb-4 rounded-lg border border-danger/40 bg-danger/10 px-3 py-2 text-xs text-danger">
              {error}
            </div>
          ) : null}

          <button className="btn-primary w-full justify-center" type="submit" disabled={busy || !password}>
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>

        {onUseApiKey ? (
          <button
            type="button"
            className="nav-link mt-4 w-full justify-center !text-xs"
            onClick={onUseApiKey}
          >
            Use an API key instead
          </button>
        ) : null}
      </div>
    </div>
  );
}
